/*
 * @Author: Chao Yang
 * @Date: 2022-07-01 14:17:13
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 14:20:26
 */
import { BaseProxy } from '../base.proxy';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RootProxy extends BaseProxy {
  getViewDataForAllInvestors() {
    if (environment.feature.newApi === false) {
      return this._http.get<boolean>(`/ip/api/preference/viewDataForAllInvestors`);
    } else {
      return this._http.get<boolean>(`/ip-api/api/preference/viewDataForAllInvestors`);
    }
  }

  updateViewDataForAllInvestors(viewDataForAllInvestors: boolean) {
    if (environment.feature.newApi === false) {
      return this._http.put(`/ip/api/preference/viewDataForAllInvestors?viewDataForAllInvestors=${viewDataForAllInvestors}`, undefined);
    } else {
      return this._http.put(`/ip-api/api/preference/viewDataForAllInvestors?viewDataForAllInvestors=${viewDataForAllInvestors}`, undefined);
    }
  }
}
